import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectAdminToken } from "../../admin/sessionSlice";
import { updateCharacter } from "../../functions/updateCharacter";
import "./character.css";

const CHARACTERS = [
  { id: 2, src: `${process.env.PUBLIC_URL}/img/char2.png` },
  { id: 1, src: `${process.env.PUBLIC_URL}/img/char1.png` },
  { id: 3, src: `${process.env.PUBLIC_URL}/img/char3.png` },
];

const NEXT_ROUTE = "/mazegame";

function Character() {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const adminToken = useSelector(selectAdminToken);
  const [selected, setSelected] = useState(null);
  const [saving, setSaving] = useState(false);

  const handleNext = async () => {
    if (!selected || !user || saving) return;
    setSaving(true);
    try {
      await updateCharacter({ userId: user.userId, character: selected, token: adminToken });
    } catch (err) {
      console.error("Failed to save character:", err);
    } finally {
      setSaving(false);
      const params = new URLSearchParams({
        userId: user.userId,
        sessionId: user.sessionId,
        organizationId: user.organizationId,
      });
      navigate(`${NEXT_ROUTE}?${params.toString()}`);
    }
  };

  return (
    <div className="character-page">
      <div className="character-heading">Choose your character</div>
      <div className="character-grid">
        {CHARACTERS.map((c) => (
          <img
            key={c.id}
            src={c.src}
            alt={`Character ${c.id}`}
            className={`character-img ${selected === c.id ? "character-img--selected" : ""}`}
            onClick={() => setSelected(c.id)}
          />
        ))}
      </div>
      <div className="character-next-holder">
        <button
          className="character-next-button"
          onClick={handleNext}
          disabled={!selected || saving}
        >
          {saving ? "Saving..." : "Next"}
        </button>
      </div>
    </div>
  );
}

export default Character;
